import { IJSLComponent, IJSLVNode, refresh, JSLRender } from "jsl-render";
import { LoadingComponent, GridComponent, ISlickCreatorOptions, ISlickColumn, DateFormatter, NumericFormatter, ComponentFormatter, DialogComponent } from "jsl-ui";
import { FundDetailsDTO } from "../../ajax/types/FundDetailsDTO";
import { DownloadExcelButtonComponent } from "./excel/DownloadExcelButtonComponent";
import { ImageGallerieComponent } from "./image-gallerie/ImageGallerieComponent";
import { PublicController } from "../../ajax/PublicController";

export class FundListComponent implements IJSLComponent {

    private data: FundDetailsDTO[];
    private grid: GridComponent<FundDetailsDTO>;
    private downloadXlsBtn: DownloadExcelButtonComponent<FundDetailsDTO>;
    private isLoading: boolean;

    constructor(request?: Promise<FundDetailsDTO[]>, private showTaxaColumn?: boolean) {
        if (request != null) {
            this.isLoading = true;
            request.then((data) => {
                this.data = data;
                this.createGrid();
                this.isLoading = false;
                refresh();
            });
        } else {
            this.data = [];
        }
    }

    public countRows(): number {
        return this.data.length;
    }

    public setData(promise: Promise<FundDetailsDTO[]>) {
        this.isLoading = true;
        if (this.grid == null) {
            this.createGrid();
            refresh();
        }
        promise.then((data) => {
            this.data = data;
            this.isLoading = false;
            refresh();
            this.grid.getRef().then((g) => {
                g.setData(this.data);
            });
        }).catch(() => {
            this.isLoading = false;
            refresh();
        });
    }

    public render(): IJSLVNode {
        return {
            tag: "div",
            attr: { style: "text-align:left" },
            children: [<div style="text-align:center">{this.isLoading ? new LoadingComponent(3) : null}</div>,
            this.grid,
            this.data?.length > 0 ? this.downloadXlsBtn : null]
        };
    }

    private createGrid() {

        const options: ISlickCreatorOptions = {
            primaryKey: "fundId",
            showHeaderMenu: true
            // autoHeight: true
        };
        const columns: ISlickColumn[] = [
            {
                id: "name",
                name: "Taxa Name",
                width: 200,
                sortable: true,
                filterable: true
            },
            {
                id: "fundDatum",
                name: "Fund Datum",
                formatter: DateFormatter,
                width: 120,
                sortable: true,
                cssClass: "right"
            },
            {
                id: "imageCount",
                name: "Bilder",
                formatter: ComponentFormatter,
                width: 70,
                sortable: true,
            },
            {
                id: "bundesland",
                name: "Bundesland",
                width: 120,
                sortable: true,
                filterable: true
            },
            {
                id: "bezirk",
                name: "Bezirk",
                width: 120,
                sortable: true,
                filterable: true
            },
            {
                id: "gemeinde",
                name: "Gemeinde",
                width: 120,
                sortable: true,
                filterable: true
            },
            {
                id: "latitude",
                name: "Lat",
                width: 80,
                sortable: true,
                formatter: NumericFormatter,
                format: "0.00000"
                //filterable: true
            },
            {
                id: "longitude",
                name: "Long",
                width: 80,
                sortable: true,
                formatter: NumericFormatter,
                format: "0.00000"
                //filterable: true
            },
            {
                id: "mtbq",
                name: "Grundfeld/Quadrant",
                width: 100,
                sortable: true,
                filterable: true,
                cssClass: "right"
            },
            {
                id: "bestimmungsQualitaet",
                name: "Best. Grad",
                width: 90,
                sortable: true,
                filterable: true
            },
            {
                id: "bestimmer",
                name: "Bestimmer",
                width: 200,
                sortable: true,
                filterable: true
            },
            {
                id: "sammler",
                name: "Sammler",
                width: 200,
                sortable: true,
                filterable: true
            },
            {
                id: "fundortName",
                name: "Fundort",
                width: 200,
                sortable: true,
                filterable: true
            },
            {
                id: "klimaTyp",
                name: "Klima",
                width: 150,
                sortable: true,
                filterable: true
            },
            {
                id: "BodenTyp",
                name: "Boden",
                width: 150,
                sortable: true,
                filterable: true
            },
            {
                id: "regionNaturraum",
                name: "Naturraum",
                width: 200,
                sortable: true,
                filterable: true
            },
            {
                id: "regionGebirgsraum",
                name: "Gebirgsraum",
                width: 200,
                sortable: true,
                filterable: true
            },
            {
                id: "meerHoeheVon",
                name: "Fundhöhe [von]",
                width: 120,
                sortable: true,
                filterable: true
            },
            {
                id: "meerHoeheBis",
                name: "Fundhöhe [bis]",
                width: 120,
                sortable: true,
                filterable: true
            },
            {
                id: "substratCode",
                name: "Fund Substrat",
                width: 180,
                sortable: true,
                filterable: true
            },
            {
                id: "substratKommentar",
                name: "Substrat Kommentar",
                width: 250,
                sortable: true
            },

            {
                id: "oekosystemCode",
                name: "Ökosystem",
                width: 120,
                sortable: true,
                filterable: true
            },
            {
                id: "oekosystemKommentar",
                name: "Ökosystem Kommentar",
                width: 190,
                sortable: true
            },
            {
                id: "herbarOef",
                name: "Herbar (öffent.)",
                width: 150,
                sortable: true,
                filterable: true
            },
            {
                id: "herbarOefNr",
                name: "Herbar Nr (öffent.)",
                width: 150,
                sortable: true,
                filterable: true
            },
            {
                id: "herbarPriv",
                name: "Herbar (privat)",
                width: 200,
                sortable: true,
                filterable: true
            },
            {
                id: "herbarPrivNr",
                name: "Herbar Nr (privat)",
                width: 200,
                sortable: true,
                filterable: true
            },
            {
                id: "datenquelle",
                name: "Datenquelle",
                width: 200,
                sortable: true,
                filterable: true
            },
            {
                id: "fundortBeschreibung",
                name: "Fundort Beschreibung",
                width: 300,
                sortable: true,
                filterable: true
            },
            {
                id: "kommentar",
                name: "Fundort Bemerkung",
                width: 300,
                sortable: true,
                filterable: true
            }
        ];
        if (this.showTaxaColumn) {
            columns.push({
                    id: "roteListeOesterreich",
                    name: "Rote Liste",
                    width: 200,
                    sortable: true,
                    filterable: true
                });
        }
        this.grid = new GridComponent(this.data, columns, options, "50vh");
        this.grid.initEvents((g) => {
            g.onAppendCell.subscribe((e, args) => {
                if (args.item != null && args.column.id === "imageCount") {
                    if (args.value) {
                        new JSLRender(args.dom).render(<button class="jsl-button" click={() => {
                            const dlgContent = <div>{new LoadingComponent()}</div>;
                            PublicController.GetFund({ id: args.item.fundId }).then((data) => {
                                dlgContent.children = [new ImageGallerieComponent(data.images)];
                                refresh();
                            });
                            const dlg = DialogComponent.show({
                                header: "Bilder",
                                content: dlgContent,
                                footer: <button class="jsl-button" click={() => dlg.getRef().close()}>OK</button>
                            });
                        }
                        }>({args.value})</button>);
                    }
                }
            });
            g.refresh();
        });
        this.downloadXlsBtn = new DownloadExcelButtonComponent(this.grid);
    }

}
